/* 商品ページ（templates/product.liquid）の動き — 現行MakeShop商品ページの挙動を移植（2026-09-26）
 *
 *  1. 画像ギャラリー: Swiper でメイン画像を切り替え（矢印・ドット・キーボード）。
 *     サムネイルをクリックするとその画像へ。スライドが変わるとサムネイルの選択表示と
 *     サムネイル列のスクロール位置（PC=縦／SP=横）を追従させる
 *  2. 数量の上下ボタン（1未満にはしない）
 *  3. オプション（カラー／保証年数／サイズ）: 色見本・行・ボタンのラジオで選ぶ（2026-10-27 デザイン変更。以前はプルダウン）。
 *     ページを開いた時点で在庫のある最初の種類が選ばれている。選ばれた組み合わせのバリアントIDをフォームに入れ、
 *     価格・選択中の名前・保証年数の各行の価格・売り切れ表示を切り替える。
 *     組み合わせが無い・未選択のままカートに入れようとしたら、その場で注意を出して送信しない
 *  4. 販売期間（2026-10-13）: 期間外（販売開始前・販売終了）はカートに入れるボタンを止める。
 *     判定は assets/kinujo-sale-period.js。ページを開いたまま開始・終了の時刻をまたいだら、その場で切り替える
 *  5. レコメンド（2026-10-28）: 「こちらの商品もおすすめです」を Shopify のレコメンド（sections/kj-reco-related.liquid）で差し替える。
 *     4件そろわなければ、ページを開いた時点の候補（同じシリーズ→同じ種別）のまま。
 *     商品のメタフィールドでおすすめを手動指定してある商品は data-url が無く、差し替えない
 *  6. 最近チェックした商品（2026-10-28）: 見た商品の handle をこのブラウザに残し（最大12件）、今の商品以外を新しい順に最大6件出す
 *  7. 商品説明（2026-10-28 整理）: 商品データの説明文 HTML を表示時に組み直す（見た目は kinujo-product.css の「商品説明」）。
 *     「-----」の区切り線より上（転売禁止・LINE）を注意書きのブロックに分ける／区切り線と空の段落を消す／「※」で始まる行を注記の見た目に／
 *     中身が無いブロックは隠す。説明文のデータそのものは変えない
 */
(function () {
  function initGallery(root) {
    var main = root.querySelector('.kj-gallery-main');
    if (!main || typeof Swiper === 'undefined') return;   // CDN未読込時は1枚目のみ表示（CSSで制御）
    var slides = main.querySelectorAll('.swiper-slide');
    var multi = slides.length > 1;
    var swiper = new Swiper(main, {
      slidesPerView: 1,
      speed: 450,
      navigation: multi ? {
        nextEl: main.querySelector('.swiper-button-next'),
        prevEl: main.querySelector('.swiper-button-prev')
      } : false,
      pagination: multi ? { el: main.querySelector('.swiper-pagination'), clickable: true } : false,
      keyboard: { enabled: true }
    });
    if (!multi) return;
    var rail = root.querySelector('.kj-thumbs-inner');
    var btns = Array.prototype.slice.call(root.querySelectorAll('.kj-thumb'));
    function setActive(index) {
      btns.forEach(function (b, n) { b.classList.toggle('is-active', n === index); });
      var el = btns[index];
      if (!el || !rail) return;
      if (rail.scrollHeight > rail.clientHeight + 1) {
        rail.scrollTo({ top: el.offsetTop - rail.clientHeight / 2 + el.clientHeight / 2, behavior: 'smooth' });
      } else if (rail.scrollWidth > rail.clientWidth + 1) {
        rail.scrollTo({ left: el.offsetLeft - rail.clientWidth / 2 + el.clientWidth / 2, behavior: 'smooth' });
      }
    }
    btns.forEach(function (b, i) { b.addEventListener('click', function () { swiper.slideTo(i); }); });
    swiper.on('slideChange', function () { setActive(swiper.activeIndex); });
    setActive(0);
  }

  function initQuantity(root) {
    var input = root.querySelector('input.productnum');
    if (!input) return;
    root.querySelectorAll('[data-spinner]').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        v += b.getAttribute('data-spinner') === 'up' ? 1 : -1;
        input.value = Math.max(1, v);
      });
    });
    input.addEventListener('change', function () {
      input.value = Math.max(1, parseInt(input.value, 10) || 1);
    });
  }

  function initVariants(root) {
    var form = root.querySelector('.kj-product-form');
    if (!form) return;
    var data = root.querySelector('.js-variants');
    var idInput = form.querySelector('.js-variant-id');
    var error = form.querySelector('.kj-form-error');
    var btn = form.querySelector('.cart-btn');
    var addBtn = form.querySelector('.add-btn');
    var price = root.querySelector('.js-price');
    var paidy = root.querySelector('._paidy-promotional-messaging');
    var labels = {
      cart: btn ? btn.getAttribute('data-label-cart') : '',
      sold: btn ? btn.getAttribute('data-label-sold') : '',
      before: btn ? btn.getAttribute('data-label-before') : '',
      after: btn ? btn.getAttribute('data-label-after') : ''
    };
    var sale = form.querySelector('.cart-add-btn[data-sale-state]');
    var saleState = function () { return sale ? sale.getAttribute('data-sale-state') : 'open'; };
    var soldOut = !!(btn && btn.hasAttribute('data-sold'));   // 表示時点で全種類売り切れか（種類を選ぶと選んだ種類で決め直す）
    // ボタンの表示：販売期間外 → 売り切れ → カートに入れる の順で決める
    var render = function () {
      if (!btn) return;
      var st = saleState();
      var closed = st === 'before' || st === 'after';
      btn.disabled = closed || soldOut;
      btn.textContent = closed ? (labels[st] || labels.sold) : (soldOut ? labels.sold : labels.cart);
      if (addBtn) addBtn.classList.toggle('sold-btn', closed || soldOut);
    };

    if (data && idInput) {
      var variants = JSON.parse(data.textContent);
      var groups = Array.prototype.slice.call(form.querySelectorAll('.js-opt'));
      var chosenValues = function () {
        return groups.map(function (g) {
          var r = g.querySelector('.js-option:checked');
          return r ? r.value : '';
        });
      };
      var find = function (vals) {
        return variants.filter(function (v) {
          return vals.every(function (c, i) { return v.options[i] === c; });
        })[0] || null;
      };
      var update = function () {
        var chosen = chosenValues();
        var complete = chosen.every(function (v) { return v !== ''; });
        var hit = complete ? find(chosen) : null;
        idInput.value = hit ? hit.id : '';
        if (hit && price) price.textContent = hit.price;
        if (hit && paidy && paidy.getAttribute('data-amount') !== hit.price) {
          paidy.setAttribute('data-amount', hit.price);
          if (typeof window._paidy === 'function') window._paidy('pm:refresh');
        }
        // 各選択肢について「ほかのオプションは今の選択のまま、これに変えたら」の種類を見て、売り切れ印と保証年数の行の価格を直す
        groups.forEach(function (g, gi) {
          var current = g.querySelector('.js-opt-current');
          g.querySelectorAll('.js-option').forEach(function (r) {
            var vals = chosen.slice();
            vals[gi] = r.value;
            var v = find(vals);
            var label = r.closest('.kj-val');
            if (label) label.classList.toggle('is-sold', !v || !v.available);
            var rowPrice = label && label.querySelector('.js-row-price');
            if (rowPrice && v) rowPrice.textContent = v.price;
            if (r.checked && current) {
              var name = label && label.querySelector('.kj-val-name');
              current.textContent = name ? name.textContent : r.value;
            }
          });
        });
        soldOut = !hit || !hit.available;
        render();
        if (error && hit) error.hidden = true;
      };
      groups.forEach(function (g) {
        g.querySelectorAll('.js-option').forEach(function (r) { r.addEventListener('change', update); });
      });
      update();
    }

    if (sale && window.kjSalePeriod) window.kjSalePeriod.watch([sale], render);

    form.addEventListener('submit', function (e) {
      var st = saleState();
      if (st === 'before' || st === 'after') {   // 念のため（ボタンは止めてある）
        e.preventDefault();
        return;
      }
      if (idInput && !idInput.value) {
        e.preventDefault();
        if (error) {
          error.textContent = error.getAttribute('data-message');
          error.hidden = false;
        }
      }
    });
  }

  // Paidy の案内を常に1行で表示する（2026-10-08 山本）
  //   ウィジェットは文字14px・ロゴ64pxを style 属性の !important で書くため CSS では縮められない。
  //   表示後に1行の幅を測り、枠より広ければ全体（ロゴ・文字・ⓘ）を同じ比率で縮める（CSS zoom）。
  //   金額の切り替え（pm:refresh）で描き直されたときと、画面幅が変わったときも測り直す。
  function initPaidyFit(root) {
    var el = root.querySelector('._paidy-promotional-messaging');
    if (!el) return;
    // ウィジェットが差し込むロゴ・ⓘ画像には alt が無い（PageSpeed の SEO・ユーザー補助で減点）ので、描かれるたびに補う（2026-10-16 山本）
    var lang = (document.documentElement.lang || 'ja').slice(0, 2);
    var infoAlt = lang === 'en' ? 'Details' : (lang === 'zh' ? '详情' : '詳細');
    var addAlt = function () {
      el.querySelectorAll('img:not([alt])').forEach(function (img) {
        img.setAttribute('alt', /info/.test(img.getAttribute('src') || '') ? infoAlt : 'Paidy');
      });
    };
    var fit = function () {
      addAlt();
      el.style.zoom = '';
      el.style.width = '';
      var inner = el.firstElementChild;
      if (!inner) return;
      var need = inner.scrollWidth;
      var have = el.clientWidth;
      if (have > 0 && need > have) {
        var z = Math.floor((have / need) * 1000) / 1000;
        // zoom をかけると枠の見た目の幅も縮むので、枠の幅は「元の幅 ÷ 倍率」にして見た目を元の幅に保つ
        el.style.zoom = String(z);
        el.style.width = Math.floor(have / z) + 'px';
      }
    };
    // requestAnimationFrame は裏で開いたタブでは止まるので setTimeout で待つ
    var timer = null;
    var schedule = function () {
      clearTimeout(timer);
      timer = setTimeout(fit, 30);
    };
    new MutationObserver(schedule).observe(el, { childList: true, subtree: true });
    window.addEventListener('resize', schedule);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);
    schedule();
  }

  // カート追加の計測（2026-10-10 山本）
  //   MakeShop と同じく gtag('event', 'add_to_cart', …) で GTM に渡す（GTM 側の Google 広告・Meta・アドエビス等が
  //   このイベントで動く）。フォーム送信でページが移る前に送りきれるよう、少し待ってから送信する
  function initCartTracking(root) {
    var form = root.querySelector('.kj-product-form');
    var data = root.querySelector('.js-track');
    if (!form || !data) return;
    var info = JSON.parse(data.textContent);
    form.addEventListener('submit', function (e) {
      if (e.defaultPrevented || typeof window.gtag !== 'function') return;   // 未選択で止めた送信は計測しない
      var idField = form.querySelector('[name="id"]');
      var v = idField && info.variants[idField.value];
      if (!v) return;
      var qty = Math.max(1, parseInt((form.querySelector('[name="quantity"]') || {}).value, 10) || 1);
      // send_to：宛先を書かないと GTM 経由の GA4 にはイベントが送られない（2026-10-12 実測）。GTM 側のきっかけは今までどおり動く
      window.gtag('event', 'add_to_cart', {
        send_to: 'G-F5H0RKCCE8',
        currency: 'JPY',
        value: v.price * qty,
        items: [{ item_id: v.sku || idField.value, item_name: info.title, item_variant: v.title, item_brand: info.vendor, price: v.price, quantity: qty }]
      });
      e.preventDefault();
      setTimeout(function () { form.submit(); }, 300);
    });
  }

  // 5. レコメンド：Shopify のおすすめが4件そろったら差し替える。取れない・足りないときは何もしない
  function initRecommendations(root) {
    var box = root.querySelector('.js-reco-related');
    if (!box || !box.getAttribute('data-url') || !window.fetch || !window.DOMParser) return;
    fetch(box.getAttribute('data-url'))
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return;
        var list = new DOMParser().parseFromString(html, 'text/html').querySelector('.product-list');
        if (!list || list.querySelectorAll('.product-list-item').length < 4) return;
        box.querySelector('.product-list').innerHTML = list.innerHTML;
        box.hidden = false;
      })
      .catch(function () {});
  }

  // 6. 最近チェックした商品：localStorage（kj_recent）に handle を新しい順で残す。
  //    消えた・非公開になった商品（404）は一覧から外して記録からも消す
  var RECENT_KEY = 'kj_recent';
  function readRecent() {
    try { var a = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); return Array.isArray(a) ? a : []; } catch (e) { return []; }
  }
  function writeRecent(a) {
    try { localStorage.setItem(RECENT_KEY, JSON.stringify(a.slice(0, 12))); } catch (e) {}
  }
  function initRecentlyViewed(root) {
    var box = root.querySelector('.js-recent');
    if (!box) return;
    var handle = box.getAttribute('data-handle');
    var list = readRecent().filter(function (h) { return typeof h === 'string' && h !== handle; });
    if (box.getAttribute('data-record') === '1') writeRecent([handle].concat(list));
    var show = list.slice(0, 6);
    if (!show.length || !window.fetch) return;
    var base = box.getAttribute('data-root').replace(/\/$/, '');
    var tax = box.getAttribute('data-tax');
    function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : String(t); return d.innerHTML; }
    Promise.all(show.map(function (h) {
      return fetch(base + '/products/' + encodeURIComponent(h) + '.js')
        .then(function (r) { return r.ok ? r.json() : (r.status === 404 ? { gone: h } : null); })
        .catch(function () { return null; });
    })).then(function (items) {
      var gone = items.filter(function (p) { return p && p.gone; }).map(function (p) { return p.gone; });
      if (gone.length) writeRecent(readRecent().filter(function (h) { return gone.indexOf(h) < 0; }));
      var html = items.filter(function (p) { return p && !p.gone && p.handle; }).map(function (p) {
        var url = base + '/products/' + p.handle;
        var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') < 0 ? '?' : '&') + 'width=600' : '';
        var price = Math.round(p.price / 100).toLocaleString('ja-JP');
        return '<li class="product-list-item">' +
          '<a href="' + esc(url) + '" class="product-image-link"><figure class="product-image-wrap">' +
          (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" width="600" height="600" loading="lazy">' : '') +
          '</figure></a>' +
          '<a href="' + esc(url) + '" class="product-name-link"><span class="product-caption">' + esc(p.title) + '</span>' +
          '<span class="product-price">￥' + price + esc(tax) + '</span></a></li>';
      }).join('');
      if (!html) return;
      box.querySelector('.product-list').innerHTML = html;
      box.hidden = false;
    });
  }

  // 7. 商品説明：表示時に組み直す（商品データは変えない）
  function isBlank(el) {
    return !el.textContent.trim() && !el.querySelector('img, iframe, video, table, .line-it-button');
  }
  // 共通の注意書き（product.liquid の .kj-desc-common）と同じ内容を商品説明から消す（2026-10-29）
  //   転売禁止・お問い合わせの行（日英中）、LINE の友だち追加ボタン（.line-it-button）、LINE ギフトの画像リンク
  var COMMON_LINE = /^.*(転売等は固くお断り|Resale is strictly prohibited|严禁转售|商品に関するお問い合わせはこちら|Contact us about this product|商品咨询请点击这里).*$/gm;
  function stripCommonNotice(box, common) {
    Array.prototype.forEach.call(box.querySelectorAll('.line-it-button, a[href*="lin.ee"], img[src*="LINE_icon"]'), function (el) {
      if (!common.contains(el)) el.remove();
    });
    var texts = [];
    var walker = document.createTreeWalker(box, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) {
      if (!common.contains(walker.currentNode)) texts.push(walker.currentNode);
    }
    texts.forEach(function (t) {
      COMMON_LINE.lastIndex = 0;
      if (!COMMON_LINE.test(t.nodeValue)) return;
      t.nodeValue = t.nodeValue.replace(COMMON_LINE, '');
      if (t.nodeValue.trim()) return;
      // 文言だけだった要素は、直後の改行ごと消す（空になった親もたどって消す）
      var el = t;
      while (el.parentNode && el.parentNode !== box && !el.parentNode.matches('.left-detail-description, .right-detail-description, .description-text') && isBlank(el.parentNode)) el = el.parentNode;
      var next = el.nextSibling;
      while (next && next.nodeType === 3 && !next.nodeValue.trim()) next = next.nextSibling;
      if (next && next.nodeName === 'BR') {
        next.remove();
      } else {
        var prev = el.previousSibling;
        while (prev && prev.nodeType === 3 && !prev.nodeValue.trim()) prev = prev.previousSibling;
        if (prev && prev.nodeName === 'BR') prev.remove();
      }
      el.remove();
    });
  }
  // 先頭／末尾の改行・空白・空の要素を消す（中の要素の端もたどる）
  function trimEdge(el, side) {
    var key = side === 'first' ? 'firstChild' : 'lastChild';
    var node = el[key];
    while (node) {
      if (node.nodeName === 'BR' || node.nodeType === 8 || (node.nodeType === 3 && !node.nodeValue.trim()) || (node.nodeType === 1 && isBlank(node))) {
        node.remove();
        node = el[key];
      } else {
        if (node.nodeType === 1 && !node.matches('table')) trimEdge(node, side);
        break;
      }
    }
  }
  function initDescription(root) {
    var box = root.querySelector('.bg-section .detail-description');
    if (!box) return;
    var left = box.querySelector('.left-detail-description');
    var right = box.querySelector('.right-detail-description');
    var common = box.querySelector('.kj-desc-common');
    stripCommonNotice(box, common);
    Array.prototype.forEach.call(box.querySelectorAll('p'), function (p) { if (isBlank(p)) p.remove(); });
    if (left) {
      // 「-----」の区切り線（全角・長音などの連続も含む）より上を注意書きのブロックへ移す
      var walker = document.createTreeWalker(left, NodeFilter.SHOW_TEXT);
      var line = null;
      while (walker.nextNode()) {
        if (/^[-－―ー─]{10,}$/.test(walker.currentNode.nodeValue.trim())) { line = walker.currentNode; break; }
      }
      if (line) {
        var range = document.createRange();
        range.setStart(left, 0);
        range.setEndBefore(line);
        var head = range.extractContents();
        var host = line.parentNode;
        line.remove();
        while (host && host !== left && isBlank(host)) { var up = host.parentNode; host.remove(); host = up; }
        // 残った商品ごとの注記（ショッパー・ネコポス等）は共通の注意書きの上に並べる
        var extra = document.createElement('div');
        extra.className = 'kj-desc-extra';
        extra.appendChild(head);
        trimEdge(extra, 'last');
        if (!isBlank(extra)) common.insertBefore(extra, common.firstChild);
      }
      trimEdge(left, 'first');
      // 「※」で始まる行を注記の見た目に（表の中は対象外）
      var notes = [];
      var w2 = document.createTreeWalker(left, NodeFilter.SHOW_TEXT);
      while (w2.nextNode()) {
        var t = w2.currentNode;
        if (t.nodeValue.trim().charAt(0) === '※' && !t.parentNode.closest('table, .kj-desc-note')) notes.push(t);
      }
      notes.forEach(function (t) {
        var span = document.createElement('span');
        span.className = 'kj-desc-note';
        t.parentNode.insertBefore(span, t);
        span.appendChild(t);
      });
    }
    [left, right].forEach(function (el) { if (el && isBlank(el)) el.classList.add('is-empty'); });
    if (isBlank(box)) box.closest('.bg-section').classList.add('is-empty');
  }

  function init() {
    var root = document.querySelector('.kj-product');
    if (!root) return;
    initGallery(root);
    initQuantity(root);
    initVariants(root);
    initPaidyFit(root);
    initCartTracking(root);
    initRecommendations(root);
    initRecentlyViewed(root);
    initDescription(root);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
